import classNames from "classnames";
import { get } from "lodash";
import Button from "../../Components/Button";

const ProductCard = ({
  icon,
  name,
  description,
  action,
  link,
  recommendation,
  disabled,
}) => {
  return (
    <div className="product--item">
      <div
        className={classNames({
          "recommended--product": recommendation?.value,
        })}
      >
        <div className="product--item--wrapper">
          <div className="product--item--header">
            <div className="product--item--header--top">
              <span className="--name">{name}</span>
              {recommendation?.value && (
                <span className="product--item--tag">
                  {recommendation?.label}
                </span>
              )}
            </div>
            <p className="product--item--description">{description}</p>
          </div>
          <div className="product--item--action">
            <Button
              type={recommendation?.value ? "primary" : "primary-light"}
              onClick={action?.onClick}
              loading={action?.loading}
              disabled={action?.disabled || disabled}
            >
              {action?.label}
            </Button>
          </div>
          <div className="product--item--link" onClick={link?.onClick}>
            {link?.label}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
